import React, { createContext, useState, useContext, useEffect } from "react";

// Create a Context for the parking state
export const ParkingContext = createContext();

// Create a provider component
export const ParkingProvider = ({ children }) => {
    const [hidePromoCode, setHidePromoCode] = useState(true);

    useEffect(() => {
        const fetchSettings = async () => {
            const response = await fetch(
                "/wp-admin/admin-ajax.php?action=pa_parking_widget_settings",
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                console.log(data.data);

                setHidePromoCode(data.data.hidePromoCode);
            } else {
                console.error("Failed to fetch parking widget settings");
            }
        };

        fetchSettings();

        return () => {};
    }, []);

    return (
        <ParkingContext.Provider value={{ hidePromoCode }}>
            {children}
        </ParkingContext.Provider>
    );
};

export const useParking = () => useContext(ParkingContext);
